"use client";

import { isFacetXParentOfFacetY } from "@/app/search/facets/categories/topLevelCategoryFacet";
import {
  CategoryFacetType,
  CategoryLevel,
  getNextCategorySearchLevel,
} from "@/app/search/utils/createUsableCategoryFacet";
import { useEffect, useState } from "react";
import facetStyle from "../genericFacet.module.scss";
import style from "./categoryFacet.module.scss";

export default function CategoryFacet({
  facet,
  parentFacet,
  level,
  modifyCallback,
  selectedFacet,
  categoryResetSignal,
}: CategoryFacetProps) {
  const [showChildren, setShowChildren] = useState(false);
  const [showActive, setShowActive] = useState(false);
  if (!level) {
    level = "lvl1";
  }
  let nextLevel = getNextCategorySearchLevel(level);
  if (!nextLevel) {
    nextLevel = "lvl2";
  }

  useEffect(() => {
    if (
      (selectedFacet && facet.nameForFaceting === selectedFacet.nameForFaceting) ||
      isFacetXParentOfFacetY(facet, selectedFacet)
    ) {
      setShowActive(true);
      setShowChildren(true);
    } else {
      setShowActive(false);
      setShowChildren(false);
    }
  }, [facet, selectedFacet]);

  useEffect(() => {
    // Reset both states when the signal changes
    if (categoryResetSignal && categoryResetSignal > 0) {
      setShowActive(false);
      setShowChildren(false);
    }
  }, [categoryResetSignal]);

  function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>): void {
    //When selectedFacet was a child of this clicked category, keep this selected and change the new selectedFacet to this.
    if (selectedFacet?.nameForFaceting !== facet.nameForFaceting && isFacetXParentOfFacetY(facet, selectedFacet)) {
      setShowActive(true);
      setShowChildren(true);
      modifyCallback(facet);
    } else {
      setShowActive(!showActive);
      if (!showActive) {
        modifyCallback(facet);
      } else {
        modifyCallback(parentFacet);
      }
    }
  }
  return (
    <li id={`${style.catItem}`}>
      <div className={`${style.catLineContainer}` + ` ${showChildren ? style.selected : ""}`} onClick={handleClick}>
        <div className={`${facetStyle.facetNameText}` + ` ${style.catName}` + ` ${showChildren ? style.selected : ""}`}>
          {facet.name}
        </div>
        <div className={`${facetStyle.count}`}>{facet.count}</div>
      </div>
      {showChildren && facet.children.length > 0 && (
        <ul className={style.childCategory}>
          {facet.children.map((childFacet) => (
            <CategoryFacet
              key={childFacet.nameForFaceting}
              facet={childFacet}
              parentFacet={facet}
              level={nextLevel}
              modifyCallback={modifyCallback}
              selectedFacet={selectedFacet}
              categoryResetSignal={categoryResetSignal}
            />
          ))}
        </ul>
      )}
    </li>
  );
}

export type CategoryFacetProps = {
  facet: CategoryFacetType;
  parentFacet?: CategoryFacetType;
  level?: CategoryLevel;
  modifyCallback: (facet: CategoryFacetType | undefined) => void;
  selectedFacet: CategoryFacetType | undefined | null;
  categoryResetSignal?: number;
};
